<template>
  <div>
    <b-card no-body class="" :class="{ 'card-transparent-background my-0': type == 'add' || type == 'view' || type=='view_add_job' }">
      <b-card-header class="card-title-garden-help-default  p-2" :class="{ 'mt-2 ': type == 'register' }">Property
        Details</b-card-header>

      <b-card-body class="" :class="{
        'p-2': type == 'profile' || type == 'edit' ,
        'py-0 pr-0 pl-4': type == 'add' || type == 'view'|| type=='view_add_job',
        'pt-0': type == 'register'
      }">
        <div class="">
          <b-row>
            <b-col sm="12" v-if="type == 'add' || type == 'edit' || type=='view_add_job' ">
              <b-form-group class="form-group-garden-help form-group-property-gh" label="Property"
                label-for="selected_property_id" :selected_property_id="selected_property_id"
                label-class="form-label-garden-help">
                <p v-if="invalid_property_id" class="error_validation_message_p_gardenhelp">
                  Please select property
                </p>
                <v-select :options="property_list" v-model="_selected_property_id" name="selected_property_id"
                  :value="selected_property_id" title="selected_property_id" placeholder="Choose property" label="address"
                  :reduce="(item) => item.id" :clearable="false" :searchable="true" required>
                </v-select>
              </b-form-group>
            </b-col>

            <b-col sm="12">
              <b-form-group class="form-group-garden-help" label="Address" label-for="address"
                label-class="form-label-garden-help">
                <p v-if="invalid_address" class="error_validation_message_p_gardenhelp">
                  Please enter address
                </p>
                <p v-if="invalid_address_longitude || invalid_address_latitude"
                  class="error_validation_message_p_gardenhelp">
                  Please select correct address
                </p>
                <gmap-autocomplete v-if="type == 'register' || type == 'add' || type == 'edit'"
                  @place_changed="updatePlace" class="form-control form-control-garden-help h-auto"
                  :country="map_countries" id="address_input" ref="addressInputRef" name="address" placeholder="Address"
                  :componentRestrictions="{country:country_code}">
                </gmap-autocomplete>
                <span v-if="type == 'view' || type=='view_add_job'" class="form-control form-control-garden-help">
                  {{ _address }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="12" >
              <InputRadio :field_label="'Property Type'" :field_model.sync="_property_type" name="property_type"
                :options="property_type_options" v-if="type == 'register' || type == 'add' || type == 'edit'"
                :is_invalid="invalid_property_type" :invalid_message="' Please select property type'" />
              <b-form-group class="form-group-garden-help" label="Property Type" label-for="property_type"
                :property_type="property_type" label-class="form-label-garden-help"
                v-if="type == 'profile' || type == 'view' || type=='view_add_job'">

                <span class="form-control form-control-garden-help">
                  {{ _property_type }}
                </span>
              </b-form-group>

            </b-col>
            <b-col sm="12">
              <b-form-group class="form-group-garden-help" label="Property Size" label-for="property_size"
                :property_size="property_size" label-class="form-label-garden-help">
                <span class="form-control form-control-garden-help">
                  <span v-if="property_size != null && property_size != ''">
                    {{ property_size }} square meters
                  </span>
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group class="form-group-garden-help" label="Site Details" label-for="site_details"
                :site_details="site_details" label-class="form-label-garden-help">
                <!-- <v-select v-if="type == 'register' || type == 'add' || type == 'edit' || type=='view_add_job'" :options="site_details_options"
                  v-model="_site_details" name="site_details" title="site_details" placeholder="Choose site details"
                  label="title" :reduce="(item) => item.value" :clearable="false" :multiple="true" required>
                </v-select> -->
                <b-form-textarea v-if="type == 'register' || type == 'add' || type == 'edit'" id="site_details"
                  class="form-control-garden-help" v-model="_site_details"
                  placeholder="Site details, any additional notes for contractor" rows="4"></b-form-textarea>
                <span v-if="type == 'profile' || type == 'view' || type=='view_add_job'" class="form-control form-control-garden-help">
                  {{ _site_details }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <p v-if="invalid_images" class="error_validation_message_p_gardenhelp">
                Please select at least one image
              </p>
              <InputFile v-if="type == 'register' || type == 'add' || type == 'edit'"
                label="Property Images <br/> (optional)" button_text="Upload images" :multiple="true" :accept="'image/*'"
                :selectedfile_prop.sync="_property_images" :with_border="true"
                :file_container_border_class="'file-preview-container-border-garden-help'" />
              <div v-if="type == 'view' || type=='view_add_job'" class="property-images-container-garden-help">
                <b-row class="mb-1 mx-0">
                  <b-col class="px-1">
                    <p class="form-label-garden-help my-2 float-left w-auto">
                      Property Images
                    </p>

                  </b-col>
                </b-row> <b-row cols-md="3" cols="1" class="justify-content-center mx-0">
                  <b-col v-for="(media, id) in selected_property_images" :key="id" class="mx-2 my-2 p-0">
                    <img :src="media.path" />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
  
<script>
import $ from "jquery";
import moment from "moment";
import InputRadio from "@/components/Inputs/InputRadio.vue";
import InputFile from "@/components/Inputs/InputFile.vue";

export default {
  name: "PropertyDetails",
  components: { InputRadio, InputFile },
  props: [
    "type",
    "address",
    "longitude",
    "latitude",
    "invalid_address",
    "invalid_address_longitude",
    "invalid_address_latitude",
    "property_type",
    "invalid_property_type",
    "property_size",
    "site_details",
    "property_images",
    "selected_property_id",
    "property_list", "selected_property_images",
    "invalid_images", "invalid_property_id",
    "country_code",
    "country",
    "county",
    "city",
  ],
  data() {
    return {
      property_type_options: [
        { label: "Residential", value: "Residential" },
        { label: "Commercial", value: "Commercial" },
      ],
      site_details_options: [
        {
          title: "Pets",
          value: "Pets",
        },
        {
          title: "Underground Electrical Cable",
          value: "Underground Electrical Cable",
        },
        {
          title: "Over Ground Electrical Cable",
          value: "Over Ground Electrical Cable",
        },
        {
          title: "Water Mains",
          value: "Water Mains",
        },
        {
          title: "Gas Mains",
          value: "Gas Mains",
        },
        {
          title: "Metered Parking Area",
          value: "Metered Parking Area",
        },
      ],

      map_countries: ["ie", "gb", "eg"],
      map_types: [],
      componentRestrictions: {},
    };
  },
  beforeMount() {
    let map_countries_str = process.env.MAP_COUNTRIES;
    this.map_countries = map_countries_str.split(",");
    console.log(this.map_countries);
    this.componentRestrictions.country = map_countries_str.split(",");
    console.log(this.componentRestrictions);
    // console.log(this.country_code)
    //
  },
  mounted() {
    console.log(this.$refs.addressInputRef)
    // console.log(this.$refs.addressInputRef.componentRestrictions)
    console.log(this.country_code)
   
  },
  methods: {
    updatePlace(place) {
      console.log(place);
      $("#address_input").val(place.formatted_address);
      //   this.$emit("update:dropoff_eircode", place.name);
      this.$emit("update:address", place.formatted_address);
      console.log(place.geometry.location.lat());
      console.log(place.geometry.location.lng());
      // this.dropoff_latitude = place.latitude;
      this.$emit("update:latitude", place.geometry.location.lat());
      // this.dropoff_longitude = place.longitude;
      this.$emit("update:longitude", place.geometry.location.lng());

      for (let i = 0; i < place.address_components.length; i++) {
        let item = place.address_components[i]
        console.log(item)
        if (item.types[0] == 'country') {
          console.log("country", item.long_name)
          this._country = item.long_name
        }
        else if (item.types[0] == 'administrative_area_level_1') {
          console.log("county", item.long_name)
          this._county = item.long_name
        }
        else if (item.types[0] == 'locality' ||
           item.types[0] == 'administrative_area_level_2') {
          console.log("city", item.long_name)
          this._city = item.long_name
        }
      }

      console.log(this._country, this._county, this._city)


      this.componentRestrictions.country = [this.country_code]
    },
  },

  computed: {
    _selected_property_id: {
      get() {
        return this.selected_property_id
      },
      set(value) {
        this.$emit("update:selected_property_id", value);
      }
    },
    _address: {
      get() {
        return this.address;
      },
      set(value) {
        this.$emit("update:address", value);
      },
    },
    _longitude: {
      get() {
        return this.longitude;
      },
      set(value) {
        this.$emit("update:longitude", value);
      },
    },
    _latitude: {
      get() {
        return this.latitude;
      },
      set(value) {
        this.$emit("update:latitude", value);
      },
    },
    
    _country: {
      get() {
        return this.country;
      },
      set(value) {
        this.$emit("update:country", value);
      },
    },
    _county: {
      get() {
        return this.county;
      },
      set(value) {
        this.$emit("update:county", value);
      },
    },
    _city: {
      get() {
        return this.city;
      },
      set(value) {
        this.$emit("update:city", value);
      },
    },
    _property_type: {
      get() {
        return this.property_type;
      },
      set(value) {
        this.$emit("update:property_type", value);
      },
    },
    _site_details: {
      get() {
        return this.site_details;
      },
      set(value) {
        this.$emit("update:site_details", value);
      },
    },
    _property_images: {
      get() {
        return this.property_images;
      },
      set(value) {
        this.$emit("update:property_images", value);
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/customer/details_components/PropertyDetails.vue